<template>
    <h2 class="mt-4 mb-3">
        Tipovací soutěž
        <select
            class="inline-select"
            :value="year"
            @input="changeYear($event.target.value)"
        >
            <option
                v-for="year in years"
                :key="year"
                :value="year">{{ year }}
            </option>
        </select>
    </h2>
</template>

<script>
export default {
    name: "CompetitionYearHeader",
    props: {
        year: {
            type: Number,
            required: true
        }
    },
    computed: {
        years() {
            return [2021, 2022, 2023, 2024, 2025];
        },
    },
    methods: {
        changeYear(year) {
            if (year !== this.year) {
                this.$router.push(`/competition/${year}`);
            }
        }
    }
};
</script>
